export default "__VITE_ASSET__0gLFn7f$__"